export const CORS_WHITELIST = [
    'http://localhost:4200',
    'http://localhost:3334',
    'http://localhost:3333',
    'http://localhost:3000',
    'http://local.quadminds.com:3000',
    'https://integration-landing.web.app',
    'https://testing.quadminds.com',
    'https://saas.quadminds.com',
    'https://test.quadminds.com',
    'https://flash.quadminds.com',
    'https://flash-test.quadminds.com',
    'http://local.quadminds.com',
    'http://local.quadminds.com:3000',
    'http://local.quadminds.com:4200',
    'qmt.dev.com',
    'qmt.dev.com:3000',
    'qmt.dev.com:4200',
    'https://app.quadminds.com',
    'https://app-test.quadminds.com',
    'https://quadminds.io',
    'https://test.quadminds.io',
    'https://orders.quadminds.com',
    'https://platform.quadminds.com',
    'https://flash-api-test.quadminds.com',
    'https://merchants-test.quadminds.com',
    'https://flash-api.quadminds.com',
    'https://stork-test.quadminds.com',
    'https://tdc.quadminds.com',
    'https://picker.quadminds.com',
    'https://picking-test.quadminds.com',
    'https://mindy-test.lat',
    'https://mindy.lat',
    'https://tms-test.quadminds.com',
    'https://tms.quadminds.com',
];
